/* Display rules mirror native Shopify discounts. Cart totals always come from Shopify. */
(function (global) {
  'use strict';
  const rules = {
    53910177972531: {size:15, saving:2500, name:'6 mm straws', offer:'15 boxes for $385 incl. GST'},
    53910179086643: {size:16, saving:2000, name:'8 mm straws', offer:'16 boxes for $330 incl. GST'},
    53910180626739: {size:5, saving:4318, name:'Spoons', offer:'5 boxes for $200 incl. GST'}
  };
  const eligible = item => Boolean(rules[item.variant_id]) && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
  function selectedTotal(id, price, quantity) {
    const rule = rules[id];
    return price * quantity - (rule ? Math.floor(quantity / rule.size) * rule.saving : 0);
  }
  function groupedItems(cart) {
    const result = [], groups = new Map();
    for (const item of cart.items) {
      if (!eligible(item)) { result.push(item); continue; }
      let row = groups.get(item.variant_id);
      if (!row) {
        row = {...item, key:'group:' + item.variant_id, groupVariantId:item.variant_id, quantity:0, final_line_price:0, original_line_price:0};
        groups.set(item.variant_id, row); result.push(row);
      }
      row.quantity += item.quantity;
      row.final_line_price += item.final_line_price;
      row.original_line_price += item.original_line_price;
    }
    return result;
  }
  function totals(cart, taxesIncluded) {
    const subtotal = cart.total_price;
    const tax = taxesIncluded ? 0 : cart.items.reduce((sum, item) => sum + (item.taxable ? Math.round(item.final_line_price / 10) : 0), 0);
    return {subtotal, tax, total:subtotal + tax};
  }
  function progress(id, quantity) {
    const rule = rules[id];
    if (!rule || !Number.isInteger(quantity) || quantity < 0) return null;
    const groups = Math.floor(quantity / rule.size), remainder = quantity % rule.size;
    const remaining = remainder ? rule.size - remainder : groups ? 0 : rule.size;
    return {...rule, groups, remaining, value:remainder || (groups ? rule.size : 0), quantity};
  }
  const api = {rules, eligible, selectedTotal, groupedItems, totals, progress};
  global.ToscaOffers = api;
  if (typeof module !== 'undefined') module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
